<template>
	<div style="position: relative;z-index: 100;" v-bind:style="heightobject">

		<div style="position:absolute;text-align: center; width: 100%; padding-top: 30px;padding-bottom: 30px;"
			v-bind:style="heightobject">
			<div class="pageitetitle ">{{title}}</div>
			<div v-if="subtitle" class="advideosubtitle"
				style="width: 80%;height: 61px;text-align: center;margin-left: auto;margin-right: auto;margin-bottom: 60px;"
				:style="subtitlestyle">
				{{subtitle}}
			</div>
			<div v-bind:style="slotviewheight">
				<slot></slot>
			</div>
		</div>

		<video  ref="videoel" @play="startplay" v-if="video" class="advideo" webkit-playsinline playsinline autoplay loop muted
			x-webkit-airplay="true">
			<source class="source" :src="video" type="video/mp4" />
		</video>
	</div>
</template>

<script>
	export default {
		name: 'advideo',
		props: ['title', 'subtitle', 'video', 'viewheight','subtitlestyle'],
		data() {
			return {
				heightobject: {
					height: "auto"
				},
				slotviewheight: {
					height: "auto"
				}
			}
		},
		methods: {
			 
			startplay:function(){
				var videoelH = this.$refs.videoel.clientHeight
			 
				this.heightobject.height = parseInt(videoelH) + "px"
			}

		},

	 

	}
</script>


<style>
	
	
	@media (min-width: 1px) {
		.pageitetitle {
			text-align: center;
			font-size: 18px;
			letter-spacing: 4px;
			padding-bottom: 15px;
		}
		.advideosubtitle{
			font-size: 4px;
		}
	}
	
	@media (min-width: 1000px) {
		.pageitetitle {
			text-align: center;
			font-size: 35px;
			letter-spacing: 10px;
			padding-bottom: 30px;
		}
		.advideosubtitle{
			font-size: 14px;
		}
		
		
	}
	
	

	.advideo {
		position: absolute;
		width: 100%;

		/* height: auto; */
		/* width: auto;   */
		/*加滤镜*/
		/* filter: blur(1px); //背景模糊设置 */
		/*-webkit-filter: grayscale(100%);*/
		/*filter:grayscale(100%); //背景灰度设置*/
		z-index: -11;
		/* object-fit: fill; */
	}
</style>
